import * as React from 'react';
import { ResponsiveImage } from './ResponsiveImage';
import { IMAGE_DEFAULTS, Sizes } from '../../consts/image';
import { IDamImage } from '../../models/content.interfaces';

export interface MaxWidths {
  XS: number;
  SM: number;
  MD: number;
  LG: number;
}

interface Props {
  image: IDamImage;
  alt: string;
  maxWidths: MaxWidths;
  quality?: number;
}

export const MaxWidthImage = ({
  image,
  alt,
  maxWidths,
  quality = IMAGE_DEFAULTS.QUALITY,
}: Props) => {
  const widths: number[] = [];

  for (let key in maxWidths) {
    widths.push(maxWidths[key]);
  }

  const imageWidths = widths.reduce((imageWidthsAcc: number[], imageWidth) => {
    imageWidthsAcc.push(imageWidth); // 1x
    imageWidthsAcc.push(imageWidth * 2); // 2x
    imageWidthsAcc.push(imageWidth * 3); // 3x
    return imageWidthsAcc;
  }, []);

  const sizes: Sizes = {
    XS: maxWidths.XS + 'px',
    SM: maxWidths.SM + 'px',
    MD: maxWidths.MD + 'px',
    LG: maxWidths.LG + 'px',
  };

  return (
    <ResponsiveImage
      image={image}
      alt={alt}
      sizes={sizes}
      imageWidths={imageWidths}
      quality={quality}
      maxWidth={maxWidths.LG + 'px'}
    />
  );
};
